import moment from 'moment';
import 'moment/locale/ru';
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['category', 'service', 'clinic', 'price', 'categorySelect', 'serviceSelect', 'doctorSelect', 'clinicSelect', 'calltouchable']
  static values = {
    city: Number,
    category: Number,
    service: Number,
    price: String,
    clinic: Number
  }

  connect() {
    this.handlePrice()
  }

  handleCategory() {
    if (this.hasServiceSelectTarget && this.hasCategorySelectTarget) {
      this.category = this.optionSelected(this.categorySelectTarget)
      this.categoryValue = this.category.value

      this.fetchServices().then(data => {
        this.serviceSelectTarget.select.setData(data.services)
        this.handleService()
      })
    }
  }

  handleService() {
    this.service = this.optionSelected(this.serviceSelectTarget)
    this.serviceValue = this.service ? this.service.value : null

    this.fetchClinics().then(data => {
      this.clinicSelectTarget.select.setData(data.clinics, false)
      this.handleClinic()
    })
  }

  handleClinic() {
    this.clinic = this.optionSelected(this.clinicSelectTarget)
    this.clinicValue = this.clinic ? this.clinic.value : null

    this.handlePrice()
  }

  handlePrice() {
    this.fetchPrice().then(data => {
      this.priceValue = data.price
    })
  }

  serviceValueChanged() {
    this.showService()
  }

  clinicValueChanged() {
    this.showClinic()
  }

  priceValueChanged() {
    this.showPrice()
  }

  showService() {
    if (this.hasServiceSelectTarget && this.hasCategorySelectTarget) {
      if (!this.service) {
        this.serviceSelectTarget.value = this.serviceValue
        this.service = this.optionSelected(this.serviceSelectTarget)
      }

      this.serviceTarget.querySelectorAll('div')[0].textContent = this.service ? this.service.dataset.opt : ''
    }
  }

  showClinic() {
    if (this.hasServiceSelectTarget && this.hasCategorySelectTarget) {
      if (!this.clinic) {
        this.clinicSelectTarget.value = this.clinicValue
        this.clinic =  this.optionSelected(this.clinicSelectTarget)
      }

      this.clinicTarget.textContent = this.clinic ? this.clinic.dataset.address : ''
    }
  }

  showPrice() {
    const price = this.priceValue || ''
    this.serviceTarget.querySelectorAll('div')[1].innerHTML = price
    this.priceTarget.innerHTML = price
  }

  fetchServices() {
    return fetch(`/services?category_id=${this.categoryValue}`, {
      headers: {
        accept: "application/json"
      }
    }).then(response => response.json())
  }

  fetchClinics() {
    return fetch(`/clinics?service_id=${this.serviceValue}&city_id=${this.cityValue}`, {
      headers: {
        accept: "application/json"
      }
    }).then(response => response.json())
  }

  fetchPrice() {
    return fetch(`/prices?service_id=${this.serviceValue}&clinic_id=${this.clinicValue}`, {
      headers: {
        accept: "application/json"
      }
    }).then(response => response.json())
  }

  optionSelected(select) {
    return select.options[select.selectedIndex]
  }

  checkCalltouch() {
    this.calltouchableTarget.value = window.Calltouch != undefined
  }
}
